jQuery(document).ready(function ($) {

// =====================
// 货币转换工具
// =====================
const CurrencyUtils = {
  getActive() {
    return window.Shopify?.currency?.active || 'USD';
  },
  getRate() {
    return parseFloat(window.Shopify?.currency?.rate || '1.0');
  },

  // 传入美元金额（非 cents）
  convert(priceInDollars) {
    return priceInDollars * this.getRate();
  },

  format(priceInDollars) {
    const amount = this.convert(priceInDollars);
    const currency = this.getActive();
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format(amount);
  },
};

// 使用示例
// CurrencyUtils.format(2999)  → "€27.77"（当前货币为 EUR 时）
// CurrencyUtils.getActive()   → "EUR"
// CurrencyUtils.getRate()     → 1.08

// 切换英寸和厘米的按钮动作
document.querySelectorAll('.kuangao-input').forEach(function(container) {
  const options = container.querySelectorAll('.input-select div');
  const sizeLabels = container.querySelectorAll('.size_width');

options.forEach(function(option) {
  option.addEventListener('click', function() {
    const prevUnit = container.querySelector('.input-select .active').textContent.trim();
    const newUnit = this.textContent.trim(); 

    // 切换 active
    options.forEach(o => o.classList.remove('active'));
    this.classList.add('active');
    sizeLabels.forEach(label => label.textContent = newUnit);

    // 转换已输入的数值
    if (prevUnit !== newUnit) {
      container.querySelectorAll('input[type="number"]').forEach(input => {
        if (input.value) {
          if (newUnit === 'cm') {
            input.value = (parseFloat(input.value) * 2.54).toFixed(2);
          } else {
            input.value = (parseFloat(input.value) / 2.54).toFixed(2);
          }
        }
      });
    }
    handleCurtainCalculation(false);
  });
});
});

    //// 刷新页面时清除所有记录
    sessionStorage.removeItem('mtsi_header_type_alerts');
    var shownAlerts = {};

    var productInputs = {},
        initPrice = $(".product__price .price .price-item").html();

    const metafieldsJson = document.getElementById("product-metafields");
        let metafields = {};
        if (metafieldsJson) {
            metafields = JSON.parse(metafieldsJson.textContent);
        }
        //console.log(metafieldsJson);

// ===== 表单有效性 + 加购拦截（与时序无关）=====
    let formValid = false;

    // 统一入口：设置内部状态 + 视觉禁用
    function setFormValidity(valid) {
        console.log("测试:" + valid);
        formValid = !!valid;
        const $btn = $(".product-form__submit");
        $btn.prop("disabled", !formValid).toggleClass("disabled", !formValid);
    }

    (function setupCartGuard() {
        const SUBMIT_SELECTOR = '.product-form__submit';
        const FORM_SELECTOR = 'product-form form, form[action*="/cart/add"]';

        // 1) 提交拦截：挂在 document 捕获阶段（委托），表单被重渲染也依然生效，且覆盖所有加购表单
        document.addEventListener('submit', function (e) {
            const form = e.target;
            if (form && form.matches && form.matches(FORM_SELECTOR)) {
                // 白名单：换色卡加购不拦截
                if (form.matches('#swatch-form')) return;

                // 提交前最后同步一次 Liner Color，确保不为空（捕获阶段，早于主题序列化 FormData）
                if (window.syncLinerColor) window.syncLinerColor();

                if (!formValid) {
                    e.preventDefault();
                    e.stopImmediatePropagation();   // 阻止主题自带的 AJAX 加购
                    alert("Please fill in all required fields!");
                }
            }
        }, true);

        // 2) 视觉自愈：监听整个 body，谁把按钮启用了、而表单还无效，就把【所有】加购按钮禁回去
        let scheduled = false;
        function enforce() {
            scheduled = false;
            if (formValid) return;                  // 表单有效就不干预，交给正常流程
            document.querySelectorAll(SUBMIT_SELECTOR).forEach(function (btn) {
                if (!btn.disabled) {
                    btn.disabled = true;
                    btn.classList.add('disabled');
                }
            });
        }
        new MutationObserver(function () {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(enforce);         // 合并同一帧的多次变动，避免抖动和性能问题
        }).observe(document.body, {
            attributes: true,
            attributeFilter: ['disabled', 'class'],
            childList: true,
            subtree: true
        });
    })();
// ===== 表单有效性 代码到此结束=====      

    function handleCurtainCalculation(forceRecalc = false, updatePriceStr = "") {
        var cafaMethod = $('input[name="mtsi_method"]:checked').val();
        if(cafaMethod == 'Rod' || cafaMethod == 'Track'){
            cafaMethod = "Rod Cafe";
        }
        const inputs = {
            productId: $('input[name="product-id"]').val(),
            variation_id: $('input[name="id"]').val() || 0,
            colorSwatch: $(".variant-picker__color").val() || "",
            method: cafaMethod || "Rod Cafe",
            header: $('input[name="mtsi_header_type"]:checked').val(),
            grommet_colour: $('input[name="grommet_colour"]:checked').val(),
            width: parseFloat($("#mtsi_custom_curtain_width").val()),
            height: parseFloat($("#mtsi_custom_curtain_height").val()),
            unit: "inches",
            panelType: $('input[name="mtsi_panel_type"]:checked').val(),
            quantity: parseInt($('.quantity input[name="quantity"]').val() || "1"),
            lining: $('input[data-name="mtsi_custom_curtain_lining"]:checked').val(),
            liningColor: $('input[data-name="mtsi_liner_color_swatch"]:checked').attr("data-color-name") || "",
            colorSku:
                $('.select-option.swatch-wrapper[data-value="' + ($("#pa_color-image").val() || "") + '"]').attr(
                    "data-sku"
                ) || "",
            linerUnitPrice: parseFloat(metafields.liner_unit_price) || 0,
            fabricUnitPrice: parseFloat(metafields.fabric_unit_price) || 0,
            gramPerSquareInches: parseFloat(metafields.gram_per_square_inches) || 0,
            linerGramPerSquareInches: parseFloat(metafields.liner_gram_per_square_inches) || 0,
            isLining: metafields.liners || "",
            //patternType: $("#msti_pattern_type").val() || "horizontal",
            patternType: "vertical",
            exchangeRate: parseFloat(1/7.0),
            startValue: "YES",
            memoryShaped: $('input[name="mtsi_memory_shaped"]:checked').val(),
            matchingTieback: $('input[name="mtsi_matching_tieback"]:checked').val(),
        };
        console.log(inputs);
        productInputs = inputs;


        // 面板数量逻辑（Split Panels）
        if (updatePriceStr != "") {
            if ("Split Panels" == inputs.panelType) {
                inputs.quantity *= 2;
            }
        } else {
            if ("Split Panels" === inputs.panelType) {
                if (2 * inputs.quantity == 1) {
                    inputs.quantity *= 2;
                }
            } else {
                if (1 === inputs.quantity) {
                    inputs.quantity = 1;
                    $('input[name="quantity"]').val(inputs.quantity);
                }
            }
        }

        let craftWidth = parseFloat(inputs.width);
        let craftHeight = parseFloat(inputs.height);
        const activeUnit = document.querySelector('.input-select .active').textContent.trim();

        if (activeUnit === 'cm') {
        craftWidth = parseFloat((craftWidth / 2.54).toFixed(2));
        craftHeight = parseFloat((craftHeight / 2.54).toFixed(2));
        }

        var totalPrice = 0;

        // 11月新版运费合同（shipping weight map）
        var shippingData = {
            "0.5": 166.6535,
            "1.0": 183.937,
            "1.5": 201.3765,
            "2.0": 243.542,
            "2.5": 285.4735,
            "3.0": 310.141,
            "3.5": 349.1605,
            "4.0": 388.18,
            "4.5": 427.1995,
            "5.0": 466.219,
            "5.5": 452.8225,
            "6.0": 487.89,
            "6.5": 522.9575,
            "7.0": 558.025,
            "7.5": 593.0925,
            "8.0": 628.16,
            "8.5": 663.2275,
            "9.0": 698.295,
            "9.5": 733.3625,
            "10.0": 768.43,
            "10.5": 893.4445,
            "11.0": 930.475,
            "11.5": 967.5055,
            "12.0": 1004.536,
            "12.5": 1041.5665,
            "13.0": 1078.597,
            "13.5": 1115.6275,
            "14.0": 1152.658,
            "14.5": 1189.6885,
            "15.0": 1226.719,
            "15.5": 1263.7495,
            "16.0": 1300.78,
            "16.5": 1337.8105,
            "17.0": 1374.841,
            "17.5": 1411.8715,
            "18.0": 1448.902,
            "18.5": 1485.9325,
            "19.0": 1522.96,
            "19.5": 1559.99,
            "20.0": 1597.02,
            "20.5": 1871.45,
            "21.0": 1902.36,
            "21.5": 1933.26,
            "22.0": 1964.17,
            "22.5": 1995.08,
            "23.0": 2025.99,
            "23.5": 2056.89,
            "24.0": 2087.8,
            "24.5": 2118.71,
            "25.0": 2149.62,
            "25.5": 2180.52,
            "26.0": 2211.43,
            "26.5": 2242.34,
            "27.0": 2273.25,
            "27.5": 2304.15,
            "28.0": 2335.06,
            "28.5": 2365.97,
            "29.0": 2396.88,
            "29.5": 2427.78,
            "30.0": 2458.69
        };

        console.log("craftHeight:" + craftHeight);
        console.log("craftWidth:" + craftWidth);
        console.log("inputs.quantity:" + inputs.quantity);

        // 帘头倍数
        if ("S-Fold" === inputs.header) {
            headerRate = 2.8;
        } else if ("Cafe Double Pinch Pleat" === inputs.header || "Double-Pinch Pleat" === inputs.header) {
            headerRate = 2;
        } else if ("Cafe Triple Pinch Pleat" === inputs.header || "Triple-Pinch Pleat" === inputs.header) {
            headerRate = 2.5;
        } else {
            headerRate = 1;
        }

        console.log("headerRate:" + headerRate);

        // 窗帘重量 = 宽*高*平方英寸克重/1000
        var freight = (craftHeight * craftWidth * inputs.gramPerSquareInches) / 1000;
        console.log("netWeight:" + freight);
        console.log("profitRrate:4.6");

        // 总重量 = 窗帘重量*帘头的倍数+0.3
        grossWeight = freight * headerRate + 0.3;

        // 总重量 = 重量取整行为（四舍五入到 0.5 的倍数）
        grossWeightIndex = (0.5 * Math.ceil(grossWeight / 0.5)).toFixed(1);
        console.log("grossWeightIndex:" + grossWeightIndex);

        var shippingCharge = 0;
        // 合同重量超出20，直接以￥71*重量
        if (grossWeightIndex > 20) {
            shippingCharge = 71 * grossWeightIndex;
        } else {
            for (let weightKey in shippingData) {
                if (Number(grossWeightIndex) == Number(weightKey)) {
                    shippingCharge = shippingData[weightKey];
                }
            }
        }

        console.log("shippingCharge:" + shippingCharge);

        // 宽度用料
        var width_material = craftWidth * headerRate;
        console.log("width_material:" + width_material);

        // 高度大于104，进入买高价格公式
        if (craftHeight > 104) {
            productPrice = craftHeight * inputs.fabricUnitPrice + 1.04 * craftHeight;
        } else {
            if (inputs.patternType === "vertical") {
                if (inputs.header === "S-Fold") {
                    productPrice = 2.8 * craftWidth * inputs.fabricUnitPrice + 2.8 * craftWidth * 0.66;
                } else if (
                    inputs.header === "Cafe Double Pinch Pleat" ||
                    inputs.header === "Double-Pinch Pleat"
                ) {
                    productPrice = 2 * craftWidth * inputs.fabricUnitPrice + 2 * craftWidth * 0.66;
                } else if (
                    inputs.header === "Cafe Triple Pinch Pleat" ||
                    inputs.header === "Triple-Pinch Pleat"
                ) {
                    productPrice = 2.5 * craftWidth * inputs.fabricUnitPrice + 2.5 * craftWidth * 0.66;
                } else {
                    productPrice = craftWidth * inputs.fabricUnitPrice + 0.66 * craftWidth;
                }
            } else {
                if (inputs.header === "S-Fold") {
                    productPrice = craftHeight * inputs.fabricUnitPrice + 2.8 * craftWidth * 0.66;
                } else if (
                    inputs.header === "Cafe Double Pinch Pleat" ||
                    inputs.header === "Double-Pinch Pleat"
                ) {
                    productPrice = craftHeight * inputs.fabricUnitPrice + 2 * craftWidth * 0.66;
                } else if (
                    inputs.header === "Cafe Triple Pinch Pleat" ||
                    inputs.header === "Triple-Pinch Pleat"
                ) {
                    productPrice = craftHeight * inputs.fabricUnitPrice + 2.5 * craftWidth * 0.66;
                } else {
                    productPrice = craftHeight * inputs.fabricUnitPrice + 0.66 * craftWidth;
                }
            }
        }

        console.log("productPrice:" + productPrice);
        console.log("exchangeRate:" + inputs.exchangeRate);

        // （（帘头倍数*高度*面料克重+帘头倍数*高度*0.5）+运费合同费）* 0.14 *利润
        totalPrice = (productPrice + shippingCharge) * inputs.exchangeRate * 4.6;

        // 判断高度大于104并且宽度用料大于106，属于超高超宽，收取50美元费用
        if (craftHeight > 104 && width_material > 106) {
            totalPrice = totalPrice + 50;
        }

        console.log("totalPrice:" + totalPrice);

        // 衬里加成 & 配套绑带费用
        if (inputs.lining && "Unlined" !== inputs.lining && "Unlined-lining" !== inputs.lining) {
            totalPrice *= 1.25;
        }
        if (inputs.matchingTieback && "Yes" == inputs.matchingTieback) {
            totalPrice += 10;
        }
        //全站涨价10%
        totalPrice = totalPrice * 1.1 * inputs.quantity;

        totalPrice = Math.floor(100 * totalPrice) / 100;
        inputs.totalPrice = totalPrice;

        // 更新页面显示
        $(".new-xqy .color").html(inputs.colorSku);
        $(".new-xqy .method").html(inputs.method);

        $(".kuangao-img a").attr(
            "href",
            "https://cdn.shopify.com/s/files/1/0752/7399/4425/files/kuangao-" + inputs.header.replaceAll(" ", "-") + ".jpg"
        );

        $(".kuangao-img img").attr(
            "src",
            "https://cdn.shopify.com/s/files/1/0752/7399/4425/files/kuangao-" + inputs.header.replaceAll(" ", "-") + ".jpg"
        );

        if ("Rod" == inputs.method && "Grommet" == inputs.header) {
            $(".mtsi_header_radio .GrommetColour").show();
            if (inputs.grommet_colour) {
                inputs.header = inputs.header + "-" + inputs.grommet_colour;
            }
        } else {
            $(".mtsi_header_radio .GrommetColour").hide();
        }

        if (inputs.header == "Cafe Rod Pocket" || inputs.header == "Rod Pocket" || inputs.header == "Back Tab" || inputs.header == "Tab Top") {
            $("#mtsi_memory_shaped .last").hide();
            inputs.memoryShaped = "No";
        } else {
            $("#mtsi_memory_shaped .last").show();
        }

        $(".new-xqy .header").html(inputs.header);
        $(".new-xqy .lining").html(inputs.lining);
        $(".new-xqy .memoryShaped").html(inputs.memoryShaped);
        $(".new-xqy .matchingTieback").html(inputs.matchingTieback);

        if(inputs.isLining){
            if(inputs.isLining == 'Unlined'){
                $('input[data-name="mtsi_custom_curtain_lining"][value="Liner"]').prop("disabled", true);
            }
        }

        if (inputs.width && inputs.height) {
            if (activeUnit === 'cm') {
                $(".width_height_html").html(inputs.width + 'cm W x ' + inputs.height + 'cm L');
            }else{
                $(".width_height_html").html(inputs.width + '"W x ' + inputs.height + '"L');
            }
            $(".kuangao").css("border", "none");
        } else {
            $(".width_height_html").html("");
            $(".kuangao").css("border", "1px dashed red");
        }
        //传递数值到隐藏表单，提交到购物车
        document.getElementById('hiddenHeader').value = inputs.header ?? '';
        if (activeUnit === 'cm') {
        document.getElementById('hiddenWidth').value = inputs.width + 'cm' ?? '';
        document.getElementById('hiddenHeight').value = inputs.height + 'cm' ?? '';           
        }else{
        document.getElementById('hiddenWidth').value = inputs.width + '"' ?? '';
        document.getElementById('hiddenHeight').value = inputs.height + '"' ?? '';
        }
        document.getElementById('hiddenMemoryShaped').value = inputs.memoryShaped ?? '';
        document.getElementById('hiddenLining').value = inputs.lining ?? '';
        document.getElementById('hiddenLinerColor').value = inputs.liningColor ?? '';

        // 提交前最后同步一次 Liner Color，确保不为空（捕获阶段，早于主题序列化 FormData）
        if (window.syncLinerColor) window.syncLinerColor();

        var appPriceInput = document.getElementById('custom-price-field');

        if (appPriceInput) {
            appPriceInput.value = totalPrice / inputs.quantity;
        }
        
        // 表单可提交性检查（立即执行函数）
        (function () {
            var okToAdd = true;
            if (!productInputs.method || !productInputs.header || !productInputs.lining) okToAdd = false;
            if (!productInputs.width || productInputs.width <= 1 || !productInputs.height || productInputs.height <= 1)
                okToAdd = false;
            if (!productInputs.lining) okToAdd = false;

            setFormValidity(okToAdd);
        })();

        // 更新价格显示（立即执行函数）
        (function (priceValue, inputsParam) {
            const priceWrapper = $(".product__price .price .price__regular"),
                hasSale = priceWrapper.find("del").length > 0 && priceWrapper.find("ins").length > 0,
                panels = inputsParam.quantity || 1,
                unitPrice = priceValue / panels;

            function formatMoney(num) {
                return CurrencyUtils.format(num.toFixed(2));
            }

            function formatPanelDisplay(totalPanels, value) {
                return "Split Panels" === inputsParam.panelType
                    ? `${panels}  × ${formatMoney(value)}`
                    : value > 0
                    ? ((panel = panels > 1 ? "Panels" : "Panel"), `${panels} ${panel} × ${formatMoney(value)}`)
                    : initPrice;
            }

            console.log(unitPrice, hasSale);

            if (hasSale) {
                const calculatedRegular =
                        (parseFloat($("#mtsi_calculated_regular_price_elemnt").data("regular")) || 100) /
                        (parseFloat($("#mtsi_calculated_regular_price_elemnt").data("sale")) || 90) *
                        priceValue,
                    currentPrice = priceValue;

                priceWrapper.find("del .price-item.price-item--regular").html(formatMoney(calculatedRegular));
                priceWrapper.find("ins .price-item.price-item--regular").html(formatPanelDisplay(0, unitPrice));
                priceWrapper.find(".screen-reader-text:first").text(`Original price was: ${formatMoney(calculatedRegular)}`);
                priceWrapper.find(".screen-reader-text:last").text(`Current price is: ${formatMoney(currentPrice)}`);
            } else {
                priceWrapper.find(".price-item.price-item--regular").html(formatPanelDisplay(0, unitPrice));
                if (0 === priceWrapper.find(".original-price").length) {
                    priceWrapper.append(
                        `<span class="original-price" style="display:none;">Original price: ${formatMoney(priceValue)}</span>`
                    );
                } else {
                    priceWrapper.find(".original-price").text(`Original price: ${formatMoney(priceValue)}`);
                }
            }

            $("#fetch_color_res_txt").html(inputsParam.colorSwatch || "");
            $("#fetch_width_res_txt").html(inputsParam.width ? inputsParam.width.toFixed(2) + '"' : "");
            $("#fetch_length_res_txt").html(inputsParam.height ? inputsParam.height.toFixed(2) + '"' : "");
            $("#fetch_header_res_txt").html(inputsParam.header || "");
            $("#fetch_lining_res_txt").html(inputsParam.lining || "");
        })(totalPrice, inputs, inputs.startValue);
    }

    var storedData = JSON.parse(localStorage.getItem("mtsi_data"));
    let defaultMethod = "Cafe-Rod";

    if (storedData) {
        defaultMethod = storedData.method;
        $('input[name="mtsi_header_type"][value="' + storedData.header + '"]').attr("checked", "checked");
        $("#mtsi_custom_curtain_width").val(storedData.result_width);
        $("#mtsi_custom_curtain_height").val(storedData.result_height);
        $('.quantity input[name="quantity"]').val(storedData.panels);
    }

    $('input[name="mtsi_method"][value="' + defaultMethod + '"]').attr("checked", "checked");
    $(".mtsi_header_radio span:first-child .wpcf7-list-item").hide();
    $("." + defaultMethod).show();

    if (metafields.liners != "Liner" && metafields.liners != null) {
        $('input[name="mtsi_method"][value="Unlined"]').attr("checked", "checked");
        $(".Lining").hide();
    }

    // 首次计算
    handleCurtainCalculation();

    // 点击加入购物车,已弃用
    $(".single_add_to_cart_button").on("click", function (evt) {
        handleCurtainCalculation(false);
        evt.preventDefault();

        (function (cartInputs, calculatedPrice) {
            if (!cartInputs.header || isNaN(cartInputs.width) || isNaN(cartInputs.height))
                return void alert("Please fill in all required fields!");
            if (!cartInputs.colorSwatch) return alert("Please choose a color"), false;

            const payload = {
                action: "cstm_add_to_cart",
                product_id: cartInputs.productId,
                variation_id: cartInputs.variation_id,
                msti_pattern_type: cartInputs.patternType,
                mtsi_color_sku: cartInputs.colorSku,
                mtsi_color_swatch: cartInputs.colorSwatch,
                mtsi_custom_curtain_method: cartInputs.method,
                mtsi_custom_curtain_header: cartInputs.header,
                mtsi_custom_curtain_panel_type: cartInputs.panelType,
                mtsi_custom_curtain_width: cartInputs.width,
                mtsi_custom_curtain_height: cartInputs.height,
                mtsi_custom_curtain_unit: cartInputs.unit,
                quantity: cartInputs.quantity,
                mtsi_custom_curtain_lining: cartInputs.lining,
                mtsi_custom_curtain_lining_color: cartInputs.liningColor,
                security: ajax_object.nonce,
                calculated_price: calculatedPrice,
                startValue: cartInputs.startValue,
                memoryShaped: cartInputs.memoryShaped,
                matchingTieback: cartInputs.matchingTieback
            };

            $.ajax({
                url: ajax_object.ajax_url,
                type: "POST",
                data: payload,
                beforeSend: function () {
                    var btn = $(".single_add_to_cart_button");
                    btn.prop("disabled", true);
                    btn.addClass("disabled");
                },
                success: function (resp) {
                    if (resp.success) {
                        localStorage.setItem("NEWCARTADDITEM", "1");
                        location.reload();
                    } else {
                        alert(resp.data.msg);
                        var btn2 = $(".single_add_to_cart_button");
                        btn2.prop("disabled", false);
                        btn2.removeClass("disabled");
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    alert("An error occurred: " + errorThrown);
                    var btn3 = $(".single_add_to_cart_button");
                    btn3.prop("disabled", false);
                    btn3.removeClass("disabled");
                }
            });
        })(productInputs, productInputs.totalPrice);
    });
    //加入购物车到此结束

    var defaultRodHeader = "Cafe Rod Pocket",
        defaultTrackHeader = "Double-Pinch Pleat",
        hasWarnedHardware = false,
        headerAutoClickCount = 0;

    $('input[name="mtsi_method"]').on("change", function () {
        if (!hasWarnedHardware) {
            alert("Note: Different hardware is suitable for different curtain heads");
            hasWarnedHardware = true;
        }

        if ("Rod" == $(this).val()) {
            $('input[name="mtsi_header_type"][value="' + defaultRodHeader + '"]').prop("checked", "checked");
        } else if ("Track" == $(this).val()) {
            $('input[name="mtsi_header_type"][value="' + defaultTrackHeader + '"]').prop("checked", "checked");
        }

        $(".mtsi_header_radio span:first-child .wpcf7-list-item").hide();
        $("." + $(this).val()).show();
        handleCurtainCalculation(false);
    });

    //使用 JSON 对象存储每个选项的状态
    var shownAlerts = JSON.parse(sessionStorage.getItem('mtsi_header_type_alerts') || '{}');

    $('input[name="mtsi_header_type"]').on("change", function () {

        /** 下面是处理弹窗显示的代码 */
        var selectedValue = $(this).val(); // 获取当前选中的值
        
        // 检查这个选项是否已经显示过提示
        if (!shownAlerts[selectedValue]) {
        // 创建弹窗
        var modal = $('<div class="custom-alert-modal"></div>').css({
            'position': 'fixed',
            'top': '0',
            'left': '0',
            'width': '100%',
            'height': '100%',
            'background': 'rgba(0, 0, 0, 0.6)',
            'display': 'flex',
            'align-items': 'center',
            'justify-content': 'center',
            'z-index': '9'
        });
        
        var modalContent = $('<div class="modal-content"></div>').css({
            'background': 'white',
            'padding': '30px',
            'border-radius': '8px',
            'max-width': '400px',
            'width': '90%',
            'text-align': 'center',
            'box-shadow': '0 4px 20px rgba(0, 0, 0, 0.3)'
        });
        
        if(selectedValue == 'Back Tab'){
        modalContent.html(
            '<h3>Please Note</h3>' +
            '<p>The Back Tap header is designed to create a naturally relaxed, informal look. For a more structured appearance with uniform folds, we recommend the Pinch Pleat or S-fold styles.</p>' +
            '<button class="confirm-btn">X</button>'
        );       
        }else{
        modalContent.html(
            '<h3>Please Note</h3>' +
            '<p>Switching the curtain header may result in a height variation of 1.5-3 inches. If you require precise and accurate curtain height, please verify using our <a href="/pages/measurement-tool" style="text-decoration: underline;font-weight: 600;color: #a53d3d;cursor: pointer;">Measuring Tool</a>.</p>' +
            '<button class="confirm-btn">X</button>'
        );
        }

        modal.append(modalContent);
        $('body').append(modal);
        
        // 点击确认按钮关闭
        modal.find('.confirm-btn').on('click', function() {
            modal.fadeOut(300, function() {
            $(this).remove();
            });
        });
        
        // 点击背景关闭
        modal.on('click', function(e) {
            if ($(e.target).hasClass('custom-alert-modal')) {
            modal.fadeOut(300, function() {
                $(this).remove();
            });
            }
        });
        
        // 记录这个选项已经显示过提示
        shownAlerts[selectedValue] = true;
        sessionStorage.setItem('mtsi_header_type_alerts', JSON.stringify(shownAlerts));
        
        } else {
        console.log('选项', selectedValue, '已经显示过提示，跳过'); // 调试用
        }
        /** 处理弹窗显示的代码结束 */

        if ("Rod" == $(this).attr("method")) {
            defaultGrommet = $(this).val();
        } else if ("Track" == $(this).attr("method")) {
            defaultTrackHeader = $(this).val();
        }

        if (
            productInputs.width &&
            !["Double-Pinch Pleat", "Triple-Pinch Pleat", "S-Fold"].includes(productInputs.header) &&
            headerAutoClickCount < 2
        ) {
            $(".elementor-26215 button").click();
            headerAutoClickCount += 1;
        }

        $(this).val() == "S-Fold" ? $(".headerTypeDescription").show() : $(".headerTypeDescription").hide();
    });

    $(
        'input[name="mtsi_header_type"] , input[name="grommet_colour"] ,input[data-name="mtsi_custom_curtain_lining"] , input[name="mtsi_memory_shaped"], input[name="mtsi_matching_tieback"],input[name="Color"], #mtsi_custom_curtain_width , #mtsi_custom_curtain_height , .quantity input.quantity__input , .liner-color-radio input'
    ).on("change", function () {
        handleCurtainCalculation(false);
    });
    //变体颜色切换会把价格更改成变体价格，需要等待shopify的更改价格函数执行后，才可以触发更改价格
    $('input[name="Color"]').on("change", function () {        
        setTimeout(() => {
            handleCurtainCalculation(false);
        }, 1000);
    });
    $("#mtsi_custom_curtain_width , #mtsi_custom_curtain_height").keypress(function (evt) {
        handleCurtainCalculation(false);
        if (13 === evt.which) evt.preventDefault();
    });

    $("#mtsi_custom_curtain_width , #mtsi_custom_curtain_height").blur(function () {
        handleCurtainCalculation(false);
    });

    var delayFlag = 0;
    setTimeout(function () {
        if (0 == delayFlag) {
            delayFlag = 1;
            if (localStorage.getItem("NEWCARTADDITEM")) {
                $(".lakit-cart__heading-link").click();
                localStorage.removeItem("NEWCARTADDITEM");
            }

            if ($("form.woocommerce-checkout ul.uael-order-review-table li + a").length) {
                $("form.woocommerce-checkout ul.uael-order-review-table li.table-row.cart_item.st-item-meta > a:first-child").remove();
                $("form.woocommerce-checkout ul.uael-order-review-table li + a").each(function () {
                    $(this).remove();
                });
            }
        }
    }, 1500);

    if (window.location.href.includes("velvet")) {
        $(".memoryShaped").parent().parent().parent().remove();
        $(".matchingTieback").parent().find(".number1").html(4);
        $(".lining").parent().find(".number1").html(5);
    }
});